import React, { useState, useRef, useEffect } from "react";
import CreateCertificateForm from "../components/CreateCertificateForm";
import CertificateEditor from "../components/CertificateEditor";
import PatientInfoSection from "../components/PatientInfoSection";
import { useAtom } from "jotai";
import { FaPrint, FaSave } from "react-icons/fa";
import ReactToPrint from "react-to-print"; // Import ReactToPrint
import {
  clinicAtom,
  doctorSettingAtom,
} from "../../_helper/constant/constant-atom";
import PrintCertificate from "../components/PrintCertificate";
import "quill/dist/quill.snow.css"; // Import Quill styles
import { useSecureUpdateItem } from "../../_helper/actions/mutation/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import CuSpinner from "../../common_component/component/CuSpinner";
import EmptyEditor from "../components/EmptyEditor";
export default function Certificate() {
  const [doctor_seting] = useAtom(doctorSettingAtom);
  const [clinic] = useAtom(clinicAtom);
  const [getVal, setGetVal] = useState("");
  const [contentData, setContentData] = useState(null);
  const [func, setFunc] = useState(null);
  const [selectedForm, setSelectedForm] = useState(null);
  const selectPageSize = "A4";

  const printRef = useRef(null); // Ref for the CertificateEditor for print

  const patchMutation = useSecureUpdateItem(`${ApiEndPoint.CLINIC}`);

  // console.log("Selected Form", selectedForm);
  // console.log(contentData);
  const funcgetVal = (val) => {
    setGetVal(val);
  };

  const triggerFunc = (val) => {
    setFunc(val);
  };

  const getsendedData = (data) => {
    // setSelectedForm({ ...selectedForm, content: data });
    setContentData(data);
  };

  const handleOnSave = () => {
    const payload = {
      action: "patchCertificate",
      id: selectedForm.id,
      content: contentData,
      clinic_id: clinic.id,
    };
    patchMutation.mutate({ data: payload });
  };

  return (
    <>
      <div className="flex gap-4">
        <CreateCertificateForm
          setSelectedForm={setSelectedForm}
          selectedForm={selectedForm}
        />
        {selectedForm?.id ? (
          <CertificateEditor
            getVal={getVal}
            header_footer_setup_data={
              doctor_seting.header_footer_setup[selectPageSize]
            }
            triggerFunc={func}
            ref={printRef} // Attach the printRef to the CertificateEditor
            setsendEditorContent={getsendedData}
            geteditorContent={
              selectedForm?.content ? selectedForm?.content : ""
            }
          />
        ) : (
          <EmptyEditor />
        )}
        <PatientInfoSection
          setVal={funcgetVal}
          triggerFunc={triggerFunc}
          isDisabled={selectedForm?.id ? false : true}
        />
      </div>

      {/* Floating Buttons */}
      {selectedForm?.id && (
        <div className="fixed bottom-6 right-6 flex flex-col gap-4">
          {/* Save Button */}
          {patchMutation.isLoading ? (
            <CuSpinner />
          ) : (
            <button
              className="bg-blue-500 text-white p-4 rounded-full shadow-lg flex items-center justify-center hover:bg-blue-600"
              onClick={() => {
                // Save functionality will go here
                handleOnSave();
                console.log("Save triggered");
              }}
            >
              <FaSave className="text-xl" />
            </button>
          )}
          {/* Print Button */}
          <ReactToPrint
            trigger={() => (
              <button className="bg-green-500 text-white p-4 rounded-full shadow-lg flex items-center justify-center hover:bg-green-600">
                <FaPrint className="text-xl" />
              </button>
            )}
            content={() => printRef.current} // Print the CertificateEditor
            pageStyle={`
            @media print {
              body {
                font-family: 'Arial', sans-serif;
                -webkit-print-color-adjust: exact;
              }
              .ql-align-center { text-align: center; }
              .ql-align-right { text-align: right; }
              .ql-size-large { font-size: 18px; }
              .ql-size-huge { font-size: 24px; }
            }
          `}
          />
        </div>
      )}
      {/* Print Certificate Component */}
      <div style={{ display: "none" }}>
        <PrintCertificate
          ref={printRef}
          header_footer_setup_data={
            doctor_seting.header_footer_setup[selectPageSize]
          }
          editorContent={contentData}
        />
      </div>
    </>
  );
}
